import {
  createRootRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { Styles, fontFamily } from "@/shared/coralreef";
import { Horizontal, Stretch } from "gls/lib";
import { percent, viewHeight, viewWidth } from "csx";
import { style } from "typestyle";
import { Sidebar } from "../shared/components/sidebar/Sidebar";
import { DashboardsContextProvider } from "../shared/context/Dashboards";
import { DebugBadge } from "../presentational/DebugBadge";
import { ShellToolbar } from "../presentational/ShellToolbar";
import { MfeErrorOverlay } from "../presentational/MfeErrorOverlay";
import { NotFoundPage } from "../pages/NotFound/NotFoundPage";
import { isShellOwnedPath } from "../single-spa-config/apps";

const appContainer = style({
  background: Styles.Colours.darkestBlue,
  color: Styles.Colours.textLight,
  fontFamily,
  overflow: "hidden",
});

function RootChrome() {
  const { location } = useRouterState();
  const isLogin =
    location.pathname === "/login" || location.pathname.startsWith("/login/");
  const isMfeRoute = !isShellOwnedPath(location.pathname);

  if (isLogin) {
    return (
      <>
        <Horizontal
          horizontalAlign="center"
          height={viewHeight(100)}
          width={viewWidth(100)}
          spacing={0}
          className={appContainer}
        >
          <main className="h-full w-full">
            <Outlet />
          </main>
        </Horizontal>
        <DebugBadge />
      </>
    );
  }

  return (
    <DashboardsContextProvider>
      <Horizontal
        horizontalAlign="center"
        height={viewHeight(100)}
        width={viewWidth(100)}
        spacing={0}
        className={appContainer}
      >
        <Horizontal
          height={percent(100)}
          width={percent(100)}
          spacing={0}
          className={style({ overflow: "hidden" })}
        >
          <Sidebar />
          <Stretch
            height={percent(100)}
            className={style({
              background: Styles.Colours.darkestBlue,
              overflowX: "hidden",
              position: "relative",
              display: "flex",
              flexDirection: "column",
            })}
          >
            <ShellToolbar />
            <div
              style={{
                flex: 1,
                width: "100%",
                minHeight: 0,
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Outlet />
              <div
                id="single-spa-app-container"
                style={{
                  position: "absolute",
                  inset: 0,
                  overflow: "hidden",
                  pointerEvents: isMfeRoute ? "auto" : "none",
                }}
              />
              <MfeErrorOverlay />
            </div>
          </Stretch>
        </Horizontal>
      </Horizontal>
      <DebugBadge />
    </DashboardsContextProvider>
  );
}

export const Route = createRootRoute({
  component: RootChrome,
  notFoundComponent: () => <NotFoundPage />,
});
